import React from "react";

const colorClasses = {
  blue: "text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-charcoal font-display font-bold",
  red: "text-red-600 bg-red-50 border border-red-200 hover:bg-red-100 hover:border-red-300",
  gray: "text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-charcoal font-display font-bold",
  gold: "text-brand-charcoal bg-brand-gold border border-brand-gold hover:bg-brand-gold/90 font-display font-bold",
  cream:
    "text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-charcoal font-display font-bold",
};

const sizeClasses = {
  sm: "px-3 py-1.5 text-sm",
  xs: "px-2 py-1 text-sm",
};

export default function SoftButton({
  type = "button",
  color = "cream",
  size = "sm",
  disabled = false,
  iconLeft = null,
  className = "",
  children,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-flex items-center justify-center font-medium rounded-lg transition-colors disabled:opacity-60 disabled:cursor-not-allowed max-lg:min-h-11 ${sizeClasses[size]} ${colorClasses[color]} ${className}`}
      {...props}
    >
      {iconLeft ? <span className="mr-1.5 inline-flex">{iconLeft}</span> : null}
      {children}
    </button>
  );
}
